<div class="conteudo-chamado">
  <div class="opcoes">
    <div class="p-3">
      <div class="titulo">
        <span>Redirecionar chamado para o atendente</span>
      </div>

      <div class="mt-5 mb-5">
        <app-botao-voltar></app-botao-voltar>
      </div>

      <div class="sub-titulo my-2">
        Selecione o atendente
      </div>

      <form [formGroup]="redirecionarChamadoForm" (submit)="doRedirecionar()">
        <div>
          <label>Atendente</label>
          <select formControlName="atendente">
            <option [ngValue]="null" selected>
              Selecionar
            </option> 
            <option *ngFor="let atendente of atendentes" [ngValue]="atendente.codAtendente">
              {{atendente.codAtendente}}
            </option>
          </select>
        </div>
        <div class="d-flex justify-content-end">
          <button class="button-primary" [disabled]="!isButtonEnabled()" type="submit">
            {{labelBotao}}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>